import React from "react";
import { cx } from "./utils";

const FilterChip = ({ label, count, active = false, onClick, title, className = "", children }) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    className={cx(
      "inline-flex items-center gap-2 rounded-xl border px-3 py-2 text-sm font-semibold transition",
      active
        ? "border-slate-900 bg-slate-900 text-white"
        : "border-slate-200 bg-white text-slate-700 hover:border-orange-300 hover:bg-orange-50",
      className
    )}
  >
    {children}
    <span>{label}</span>
    {typeof count === "number" ? (
      <span
        className={cx(
          "rounded-full px-1.5 py-0.5 text-xs font-bold",
          active ? "bg-white/20 text-white" : "bg-slate-100 text-slate-600"
        )}
      >
        {count}
      </span>
    ) : null}
  </button>
);

export default FilterChip;
